<!--  -->
<template>
  <div class="cloanav">
    <div>当前位置:&nbsp;&nbsp;</div>
    <div class="child" @click="pagecheck(0)">煤矿主场景</div>
    <div class="child" @click="pagecheck(1)" v-show="twopageshow">{{twopage}}</div>
    <div class="child" v-show="threepageshow">{{threepage}}</div>
  </div>
</template>

<script>
// import { connect, close } from "../../api/scoket";
// import { connect2, close2 } from "../../api/scoket2";
// import { connect3, close3 } from "../../api/scoket3";
export default {
  data() {
    return {
      twopage: "",
      threepage: ">掘进机设备",
      threepageshow: false,
      twopageshow: false
    };
  },

  mounted() {
    this.emit.$on("item", e => {
      // console.log(e, "dada333");
      if (e == 0) {
        this.twopageshow = false;
        this.threepageshow = false;
        // connect();
      } else if (e == 1) {
        this.twopage = ">采煤工作面";
        this.twopageshow = true;
        this.threepageshow = false;
        // connect('ws://116.62.17.126:8007/ws/stream?topics=d3_sensor_data');
      } else if (e == 2) {
        this.twopage = ">掘进工作面";
        this.twopageshow = true;
        this.threepageshow = false;
        // connect('ws://116.62.17.126:8007/ws/stream?topics=d3_sensor_data');
      } else if (e == 3 || e == 4) {
        this.threepageshow = true;
        if (e == 3) {
          // connect3();
          this.threepage = ">采煤机设备"
        } else if (e == 4) {
          this.threepage = ">掘进机设备"
          // connect2();
        }
      }
    });
  },

  components: {},

  computed: {},

  methods: {
    pagecheck(val) {
      console.log("dasdasd", val);
      if (val == 0) {
        this.emit.$emit("item3", 0);
      } else if (val == 1) {
        if (this.twopage == ">采煤工作面") {
          this.emit.$emit("item3", 1);
        } else {
          this.emit.$emit("item3", 2);
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.cloanav {
  display: flex;
  width: auto;
  font-size: 13px;
  font-family: "Microsoft YaHei";
  color: rgb(255, 255, 255);
  position: absolute;
  left: 9vw;
  top: 7.5vh;
  .child {
    cursor: pointer;
  }
}
</style>